import request from '@/utils/request'
import type * as investor from '@/typings/investor'
import type * as common from '@/typings/common'

// 投资人

// 新建/编辑投资人
interface ISaveInvestorRequest {
  investor_info: investor.InvestorTypes
}
export async function saveInvestor(params: ISaveInvestorRequest) {
  return request('/api/v2/project/investor_info_save', {
    method: 'POST',
    data: params
  })
}

// 获取投资人列表
export async function getInvestorList(params: any) {
  return request('/api/v2/project/investor_info_list', {
    method: 'GET',
    data: params
  })
}

// 删除投资人
export async function delInvestor(params: any) {
  return request('/api/v2/project/investor_info_delete', {
    method: 'POST',
    data: params
  })
}

// 获取投资人详情
export async function getInvestorDetail(params: any) {
  return request('/api/v2/project/investor_info_get', {
    method: 'GET',
    data: params
  })
}

// 获取部分投资人详情
export async function getInvestorDetailByIds(params: any) {
  return request('/api/v2/project/investor_info_list_by_ids', {
    method: 'POST',
    data: params
  })
}

// 获取部分投资人详情
export async function getCurrencyList(params: any) {
  return request('/api/v2/project/investor_currency_list', {
    method: 'GET',
    data: params
  })
}

interface IGetContactListRequest {
  address_codes?: string[];
  email?: string;
  investor?: string;
  name?: string;
  page?: number;
  position?: string;
  size?: number;
  sort?: string;
}
// 获取联系人列表
export async function getContactList(params: IGetContactListRequest) {
  return request('/api/v2/project/investor_contact_search', {
    method: 'GET',
    data: params
  })
}

// 获取联系人详情
export async function getContactDetail(params: common.IdParams) {
  return request('/api/v2/project/investor_contact_get', {
    method: 'GET',
    data: params
  })
}
interface IUpdateContactDetailRequest {
  investor_contact: investor.ContactsTypes
}
// 编辑联系人信息
export async function updateContactDetail(params: IUpdateContactDetailRequest) {
  return request('/api/v2/project/investor_contact_update', {
    method: 'POST',
    data: params
  })
}

// 删除联系人
export async function deleteContact(params: common.IdParams) {
  return request('/api/v2/project/investor_contact_delete', {
    method: 'POST',
    data: params
  })
}
